import { useMutation } from 'react-query';
import { network } from 'services/network';

import { Range } from 'components/common/GlobalFilterComponent/components/RangeFilter/rangeFilter';
import { QuickAnswerFilter } from 'components/common/GlobalFilterComponent/components/quickAnswerFilter/quickAnswerFilter';

import { IFilter } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { Aggregation } from 'components/widgets/resourcesAnalysisChart/resourcesAnalysisChart.constants';

const mutationFn = (params: QueryParams) => {
    return network.post('api/bo/extractProductivityTableCardToCsv', params).then((response) => {
        const blob = new Blob([response.data], {
            type: 'text/plain',
        });
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = `${params.fileName}.csv`;
        a.click();

        return true;
    });
};

export const useMutationExtractProductivityTableCardToCsv = () => {
    return useMutation<unknown, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    metaDataId: number | undefined;
    comparedMetaDataId: number | undefined;
    range: Range | undefined;
    startDate: number | null;
    endDate: number | null;
    filter: {
        filters: IFilter[];
    };
    aggregation: Aggregation;
    quickAnswerFilter?: QuickAnswerFilter;
    fileName?: string;
}
